module.exports = __webpack_public_path__ + "img/茜草.7a09bf3a.jpg";